import React, { createContext, useContext, useState } from 'react';

const BusinessContext = createContext(null);

export const BusinessProvider = ({ children, business: initialBusiness }) => {
    const [business, setBusiness] = useState(initialBusiness);

    return (
        <BusinessContext.Provider value={{ business, setBusiness }}>
            {children}
        </BusinessContext.Provider>
    );
};

export const useBusinessContext = () => {
    return useContext(BusinessContext);
};

export default BusinessContext;

